import dateConversion from './../dateConversion';

export default {
    install(Vue) {
        Vue.filter('formatDate', function (value) {
            return dateConversion.converteISOToDate(value);
        });
    }
}